export default __webpack_public_path__ + "static/media/FD-Shop_Drawing.5a58fc42.pdf";